<template>
 <div>
   protocol item rule
 </div>
</template>

<script>
export default {
  name: 'protocolItemRule',
  mixins: [],
  components: {
  },
  props: {
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
  },
  created() {
  },
  mounted() {
  },
};
</script>

<style>

</style>
